import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  setDoc,
  Unsubscribe,
} from "firebase/firestore";
import { Project } from "../data/projects";
import { firestoreDb } from "../lib/firebase";
import { mapProjectDocument, sortProjects } from "./projects";

const PROJECTS_COLLECTION = "projects";

function requireFirestore() {
  if (!firestoreDb) {
    throw new Error("Firebase is not configured for this build.");
  }

  return firestoreDb;
}

export function subscribeToAllProjects(
  onProjects: (projects: Project[]) => void,
  onError: (error: Error) => void,
): Unsubscribe {
  const db = requireFirestore();

  return onSnapshot(
    collection(db, PROJECTS_COLLECTION),
    (snapshot) => {
      const projects = snapshot.docs
        .map((document) => mapProjectDocument(document, true))
        .filter((project): project is Project => Boolean(project));

      onProjects(sortProjects(projects));
    },
    onError,
  );
}

export async function saveProject(project: Project) {
  const db = requireFirestore();

  await setDoc(doc(db, PROJECTS_COLLECTION, project.id), project);
}

export async function deleteProject(projectId: string) {
  const db = requireFirestore();

  await deleteDoc(doc(db, PROJECTS_COLLECTION, projectId));
}
